export default "__VITE_ASSET__B5oki45c__"